<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-btn slot="activator" icon>
        <v-icon >add</v-icon>
      </v-btn>

      <v-card>

        <v-toolbar card dark color="primary">
          <v-toolbar-title>Criar Formando</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
           <v-flex xs5>
            <div class="display-1">{{projetoCodigo}} </div>
           </v-flex>
          <v-flex xs7>
            <div class="headline">{{projetoCurso}} </div>
            <div>{{projetoFaculdade}}</div>
           </v-flex>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
           <v-flex xs12>
              <v-text-field
                id="nomecompleto"
                name="nomecompleto"
                label="Nome Completo"
                v-model="nomecompleto"
                required></v-text-field>
            </v-flex>
            <v-flex xs12>
            <v-text-field
                id="email"
                name="Email"
                label="Email"
                v-model="email"
                :rules="[rules.required, rules.email]"
                required></v-text-field>
            </v-flex>
   
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click.native="criarFormando">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "FormandoCriar",
  props: {
    projetoNo: {
      type: String,
      required: true
    },
    projetoCodigo: {
      type: String,
      required: true
    },
    projetoCurso: {
      type: String,
      required: true
    },
    projetoFaculdade: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      nomecompleto: "",
      email: "",
      rules: {
        required: value => !!value || "Email obrigatório",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail inválido";
        }
      }
    };
  },
  methods: {
    criarFormando() {
      let email = this.email.toLowerCase().trim();
      let emailkey = email.replace(/[.]/g, ",");
      let updates = {};
      let agradecimentos = {
        familiar: {
          titulo: "Aos que amo",
          nomes: "",
          texto: ""
        },
        pessoal: {
          titulo: "Agradecimento Pessoal",
          texto: ""
        },
        encarte: {
          texto: ""
        }
      };
      updates["/users/" + emailkey + "/nomecompleto"] = this.nomecompleto;
      updates["/users/" + emailkey + "/email"] = email;
      updates["/users/" + emailkey + "/projeto/atual"] = this.projetoNo;
      updates[
        "/users/" + emailkey + "/projeto/projetos/" + this.projetoNo + "/curso/"
      ] = this.projetoCurso;
      updates[
        "/users/" +
          emailkey +
          "/projeto/projetos/" +
          this.projetoNo +
          "/faculdade/"
      ] = this.projetoFaculdade;
      updates[
        "/users/" +
          emailkey +
          "/projeto/projetos/" +
          this.projetoNo +
          "/dados/agradecimentos/"
      ] = agradecimentos;
      updates[
        "/projetos/" +
          this.projetoNo +
          "/formandos/" +
          emailkey +
          "/nomecompleto"
      ] = this.nomecompleto;
      updates[
        "/projetos/" + this.projetoNo + "/formandos/" + emailkey + "/email"
      ] = email;
      updates["/projetos/" + this.projetoNo + "/curso"] = this.projetoCurso;
      updates[
        "/projetos/" + this.projetoNo + "/faculdade"
      ] = this.projetoFaculdade;
      updates["/find/" + emailkey + "/nomecompleto"] = this.nomecompleto;
      updates["/find/" + emailkey + "/contrato/"] = this.projetoNo;
      updates["/find/" + emailkey + "/curso/"] = this.projetoCurso;
      updates["/find/" + emailkey + "/faculdade/"] = this.projetoFaculdade;
      this.$db.ref().update(updates);
      this.nomecompleto = "";
      this.email = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FormandoCriar.vue